import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { FILTERS } from '@sorare/core/src/lib/filters';

import ConnectedRangeSlider from '@sorare/marketplace/src/search/RangeSlider';
import AdvancedCardSearch, {
  FullProps,
} from '@sorare/marketplace/src/searchCards/AdvancedCardSearch';
import { makeRangeFilter } from '@sorare/marketplace/src/searchCards/RangeSlider';

import { InfoModal } from 'components/cards/InfoModal';

export const RefineTenGameAverageScore = makeRangeFilter(({ visible }) => {
  return (
    <ConnectedRangeSlider
      attribute={FILTERS.nbaTenGameAverageScore.attribute}
      visible={visible}
    />
  );
}, FILTERS.nbaTenGameAverageScore);

export const NBACardSearch = (
  props: Omit<
    FullProps,
    'sport' | 'CardResultsComponent' | 'PlayerDetailsComponent'
  >
) => (
  <AdvancedCardSearch
    sport={Sport.NBA}
    PlayerDetailsComponent={InfoModal}
    {...props}
  />
);

export default NBACardSearch;
